import { render, staticRenderFns } from "./ModalReturnPolicy.vue?vue&type=template&id=47921126&scoped=true&lang=pug&"
import script from "./ModalReturnPolicy.vue?vue&type=script&lang=js&"
export * from "./ModalReturnPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ModalReturnPolicy.vue?vue&type=style&index=0&id=47921126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47921126",
  null
  
)

export default component.exports